const config = {
	apiKey: "AIzaSyDsqEP10DtnLH6DqbsrOR6gODHBkCIwUF4",
	authDomain: "atc-bi.firebaseapp.com",
	databaseURL: "https://atc-bi.firebaseio.com",
	projectId: "atc-bi",
	storageBucket: "atc-bi.appspot.com",
	messagingSenderId: "1062412169696",
	appId: "1:1062412169696:web:7a9da5a00d263bdb12bb85",
	measurementId: "G-2NJ69Y7LBG"
};

export default config